<template>
  <v-container class="container">
    <v-layout row wrap>
      <div class="lds-dual-ring" v-show="showLoadingTimeIn"></div>
      <v-flex xs5 v-show="!showLoadingTimeIn">
        <v-switch
          v-model="model"
          @change="openModal(model)"
          color="primary"
          label="Horario para entrada de alumnos"
          class="mt-0"
          :disabled="disableFields"
        ></v-switch>
        <v-layout row :class="!model ? 'text-disabled' : ''">
          <v-flex>Hora de entrada</v-flex>
        </v-layout>
        <div class="border-section pa-3">
          <v-layout v-for="(day, index) in timeIn" :key="index" row>
            <v-flex
              xs4
              :class="
                timeIn[index] === null || !model || disableFields
                  ? 'text-disabled'
                  : ''
              "
            >
              {{ (index + 1) | days }}
            </v-flex>
            <v-flex
              :class="`${invalidDates[index + 1]['in'] ? 'invalid_date' : ''}`"
            >
              <v-layout align-center class="datepicker-container">
                <v-icon class="clock-notice"> schedule </v-icon>
                <vue-timepicker
                  class="pickers"
                  full-width
                  drop-direction="auto"
                  format="hh:mm a"
                  header-color="primary"
                  manual-input
                  v-model="timeIn[index]"
                  :disabled="timeIn[index] === null || !model || disableFields"
                />
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- <p v-show="isValidTimeIn === false">Horario personalizado inválido</p> -->
        </div>

        <div class="border-tol pa-1 mt-3">
          <v-layout row>
            <v-flex
              xs4
              style="margin: auto"
              :class="!model ? 'text-disabled' : ''"
            >
              Tolerancia
            </v-flex>
            <v-flex>
              <v-layout align-center class="datepicker-container">
                <v-icon class="clock-notice"> schedule </v-icon>
                <vue-timepicker
                  :minute-interval="5"
                  :hour-range="[[0, 5]]"
                  class="pickers"
                  full-width
                  drop-direction="up"
                  header-color="primary"
                  manual-input
                  v-model="tolerance"
                  :disabled="!model || disableFields"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <hr style="margin: 0px auto" />
      <v-flex xs5>
        <v-switch
          style="opacity: 0; pointer-events: none"
          color="primary"
          class="mt-0"
          label="Horario para entrada de alumnos"
        ></v-switch>
        <v-layout row>
          <v-flex>Hora de Salida</v-flex>
        </v-layout>
        <div class="border-section pa-3">
          <v-layout v-for="(day, index) in timeOut" :key="index" row>
            <v-flex
              xs4
              :class="
                timeOut[index] === null || disableFields ? 'text-disabled' : ''
              "
            >
              {{ (index + 1) | days }}
            </v-flex>
            <v-flex
              :class="`${invalidDates[index + 1]['out'] ? 'invalid_date' : ''}`"
            >
              <v-layout align-center class="datepicker-container">
                <v-icon class="clock-notice"> schedule </v-icon>
                <vue-timepicker
                  class="pickers"
                  full-width
                  drop-direction="auto"
                  format="hh:mm a"
                  header-color="primary"
                  manual-input
                  v-model="timeOut[index]"
                  :disabled="timeOut[index] === null || disableFields"
                />
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- <p v-show="isValidTimeOut === false">Horario personalizado inválido</p> -->
        </div>
      </v-flex>
      <div id="container">
        <v-dialog v-model="dialog" max-width="500" persistent>
          <v-card style="text-align: center">
            <v-icon x-large class="py-2" color="red">warning</v-icon>

            <v-card-title
              class="center_btns"
              style="font-weight: 700; font-size: 17px"
              primary-title
            >
              ¿Estas seguro que deseas deshabilitar el uso del horario para los
              alumnos de este nivel?
            </v-card-title>

            <v-card-text>
              Al deshabilitarlo, ya no se tomará en cuenta el horario de entrada
              configurado.
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions class="center_btns">
              <v-btn
                class="custom-border"
                @click="notCancel()"
                depressed
                outline
                >No, Cancelar</v-btn
              >
              <v-btn
                class="custom-border"
                style="
                  font-size: 14px;
                  background: #f44336;
                  color: #fff;
                  font-weight: 500;
                "
                depressed
                @click="cancelScheduleEvt"
                >Si, Continuar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-layout>
    <!-- <Error v-model="showError" :fixed="true" text="Ups! no pudimos guardar la configuración, es necesario que asignes un horario a cada uno de los días hábiles."></Error> -->
  </v-container>
</template>

<script>
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
import Cancel from '../../Dialogs/CancelLevelSchedule.vue'
// import Error from "../../Dialogs/Error.vue"
export default {
  props: ['levelInfo', 'invalidScheduleDates', 'userPermissions'],
  components: {
    VueTimepicker,
    Cancel,
    // Error
  },
  data() {
    return {
      // showError: false,
      invalidDatesInitialState: {
        1: {
          in: false,
          out: false,
        },
        2: {
          in: false,
          out: false,
        },
        3: {
          in: false,
          out: false,
        },
        4: {
          in: false,
          out: false,
        },
        5: {
          in: false,
          out: false,
        },
        6: {
          in: false,
          out: false,
        },
        7: {
          in: false,
          out: false,
        },
      },
      isSomeDayInvalidIn: [],
      isSomeDayInvalidOut: [],
      invalidDaysIn: [],
      invalidDaysOut: [],
      invalidDates: {},
      showLoadingTimeIn: false,
      CancelSchedule: {
        modal: false,
      },
      isCustomTimeIn: null,
      isCustomTimeOut: null,
      dialog: false,
      model: null,
      timeIn: [null, null, null, null, null, null, null],
      timeOut:
        // Array(7).fill(null),
        [null, null, null, null, null, null, null],
      scheduleDays: [
        {
          dayOfWeek: 1,
          startTime: '00:00:00',
          // "startTime": "00:00 am",
          endTime: '00:00 am',
        },
        {
          dayOfWeek: 2,
          startTime: '00:00:00',
          // "startTime": "00:00 am",
          endTime: '00:00 am',
        },
        {
          dayOfWeek: 3,
          startTime: '00:00:00',
          // "startTime": "00:00 am",
          endTime: '00:00 am',
        },
        {
          dayOfWeek: 4,
          startTime: '00:00:00',
          // "startTime": "00:00 am",
          endTime: '00:00 am',
        },
        {
          dayOfWeek: 5,
          startTime: '00:00:00',
          // "startTime": "00:00 am",
          endTime: '00:00 am',
        },
        {
          dayOfWeek: 6,
          startTime: '00:00:00',
          // "startTime": "00:00 am",
          endTime: '00:00 am',
        },
        {
          dayOfWeek: 7,
          startTime: '00:00:00',
          // "startTime": "00:00 am",
          endTime: '00:00 am',
        },
      ],
      isValidTimeOut: null,
      isValidTimeIn: null,
      tolerance: '',
      disableFields: true,
    }
  },
  filters: {
    days: function (value) {
      switch (value) {
        case 1:
          return 'Lunes'
        case 2:
          return 'Martes'
        case 3:
          return 'Miércoles'
        case 4:
          return 'Jueves'
        case 5:
          return 'Viernes'
        case 6:
          return 'Sábado'
        case 7:
          return 'Domingo'
        default:
          return ''
      }
    },
  },
  beforeMount() {
    this.invalidDates = structuredClone(this.invalidDatesInitialState)
  },
  methods: {
    userPermissionFieldsHandler() {
      this.disableFields = this.userPermissions['UPDATE_LEVELS'] ? false : true
    },
    openModal(model) {
      if (!model) {
        this.dialog = true
      }
    },
    cancelScheduleEvt() {
      this.model = false
      this.dialog = false
    },
    notCancel() {
      this.model = true
      this.dialog = false
    },
    formatMinutes(mins) {
      // do not include the first validation check if you want, for example,
      // getTimeFromMins(1530) to equal getTimeFromMins(90) (i.e. mins rollover)
      if (mins >= 24 * 60 || mins < 0) {
        throw new RangeError(
          'Valid input should be greater than or equal to 0 and less than 1440.'
        )
      }
      var h = (mins / 60) | 0,
        m = mins % 60 | 0
      return moment.utc().hours(h).minutes(m).format('HH:mm')
    },
    _parseTime(departureTime = null, revert = false) {
      let hours = '12'
      let minutes = '00'
      let amPm = 'am'

      if (departureTime === null || departureTime === '') {
        console.warn('invalid departureTime value')
        return null
      }

      if (revert) {
        minutes = departureTime.substring(3, 5)

        if (
          departureTime.substring(0, 2).includes('12') &&
          departureTime.substring(6, 8).includes('am')
        ) {
          hours = '00'
          return `${hours}:${minutes}:00`
        }

        if (
          departureTime.substring(0, 2).includes('12') &&
          departureTime.substring(6, 8).includes('pm')
        ) {
          hours = '12'
          return `${hours}:${minutes}:00`
        }

        if (departureTime.substring(6, 8).includes('am')) {
          hours = departureTime.substring(0, 2)
          return `${hours}:${minutes}:00`
        }

        hours = parseInt(departureTime.substring(0, 2)) + 12
        return `${hours}:${minutes}:00`
      }

      const [hh, mm] = departureTime.split(':')
      minutes = mm

      if (hh === '12') {
        hours = '12'
        amPm = 'pm'
        return `${hours}:${minutes} ${amPm}`
      }

      if (hh === '00') {
        hours = '12'
        amPm = 'am'
        return `${hours}:${minutes} ${amPm}`
      }

      const totalHrs = 12
      const isAmPm = parseInt(hh) <= 11

      hours = isAmPm ? hh : `${parseInt(hh) - totalHrs}`

      amPm = isAmPm ? 'am' : 'pm'

      const add0Prefix = hours.length === 1

      hours = add0Prefix ? `0${hours}` : hours

      return `${hours}:${minutes} ${amPm}`
    },
    _isCustomTime({ departureTime = '', customDepartureTime = [] }) {
      const everyDayIsSame = (arr = [], isSame = []) => {
        const cleanArr = arr.filter((e) => e !== null)
        const cleanIsSame = isSame.filter((e) => e !== null)
        let a = []

        for (let i = 0; i < cleanArr.length; i++) {
          cleanIsSame.every((e) => e === cleanArr[i])
          a.push(cleanIsSame.every((e) => e === cleanArr[i]))
        }

        return a.every((e) => e === true)
      }
      if (everyDayIsSame(customDepartureTime, customDepartureTime)) {
        return false
      }

      return customDepartureTime.some((e) => e !== departureTime && e !== null)
    },
    _sleep(ms = 100) {
      return new Promise((r) => setTimeout(r, ms))
    },
  },
  watch: {
    timeIn: function (newVal, _) {
      if (this.timeIn.length === 0) {
        this.showLoadingTimeIn = true
      } else {
        this.showLoadingTimeIn = false
      }

      const removeUnableDays = (ableDays = [], scheduleDays = []) => {
        let array = Array(7).fill(null)
        const ableDaysIds = ableDays.map((e) => e.id).sort((a, b) => a - b)

        for (let i = 0; i < ableDaysIds.length; i++) {
          array[ableDaysIds[i] - 1] = scheduleDays.filter(
            (e) => e.dayOfWeek === ableDaysIds[i]
          )[0]
        }

        return array.filter((e) => e !== null)
      }

      const _validRegex = new RegExp(/\d{2}:\d{2}(\s)(am|pm)/)

      // ALLOW ANY ABLE DAY IF IS EXTRA LEVEL
      if (this.levelInfo.isExtra) {
        this.invalidDaysIn = newVal.map((e) => {
          if (e !== null && e !== '') {
            return _validRegex.test(e)
          }
          return null
        })
      } else {
        this.invalidDaysIn = newVal.map((e) =>
          e !== null ? _validRegex.test(e) : null
        )
      }

      this.isSomeDayInvalidIn = this.invalidDaysIn.some((e) => e === false)

      if (this.isSomeDayInvalidIn || this.isSomeDayInvalidOut) {
        this.isValidTimeIn = false

        const a = this.scheduleDays.map((e, i) => {
          const a = {}
          a.startTime = this.invalidDaysIn[i]
            ? this._parseTime(this.timeIn[i])
            : null
          a.endTime = this.invalidDaysOut[i]
            ? this._parseTime(this.timeOut[i])
            : null
          a.dayOfWeek = e.dayOfWeek
          return a
        })

        this.$emit(
          'invalidScheduleDates',
          structuredClone(
            removeUnableDays(this.$store.getters.getBranch.ableDays, a)
          )
        )
        this.$emit('onIsValidCustomHoursPerDay', this.isValidTimeIn)
        return
      }

      // const isCustomTime = this._isCustomTime({ departureTime: this._parseTime(this.levelInfo.departureTime), customDepartureTime: newVal })

      const _everyDayIsSame = (arr = [], isSame = []) => {
        const cleanArr = arr.filter((e) => e !== null)
        const cleanIsSame = isSame.filter((e) => e !== null)
        let a = []

        for (let i = 0; i < cleanArr.length; i++) {
          cleanIsSame.every((e) => e === cleanArr[i])
          a.push(cleanIsSame.every((e) => e === cleanArr[i]))
        }

        return a.every((e) => e === true)
      }

      this.scheduleDays = this.scheduleDays.map((e, i) => ({
        ...e,
        startTime: this._parseTime(this.timeIn[i], true),
        endTime: this._parseTime(this.timeOut[i], true),
      }))

      // const isCustomTimeIn = !_everyDayIsSame(newVal, newVal)
      const isCustomTimeIn = newVal.every((e) => e !== undefined || e != null)
      this.isCustomTimeIn = isCustomTimeIn

      this.$emit('invalidScheduleDates', [])
      this.$emit(
        'onCustomHoursPerDay',
        removeUnableDays(
          this.$store.getters.getBranch.ableDays,
          this.scheduleDays
        )
      )

      this.isValidTimeIn = true
      this.$emit(
        'onIsValidCustomHoursPerDay',
        (this.isValidTimeIn && isCustomTimeIn && this.model) ||
          this.isCustomTimeOut
      )
    },

    timeOut: function (newVal, _) {
      const removeUnableDays = (ableDays = [], scheduleDays = []) => {
        let array = Array(7).fill(null)
        const ableDaysIds = ableDays.map((e) => e.id).sort((a, b) => a - b)

        for (let i = 0; i < ableDaysIds.length; i++) {
          array[ableDaysIds[i] - 1] = scheduleDays.filter(
            (e) => e.dayOfWeek === ableDaysIds[i]
          )[0]
        }

        return array.filter((e) => e !== null)
      }

      const isCustomTimeOut = this._isCustomTime({
        departureTime: this._parseTime(this.levelInfo.departureTime),
        customDepartureTime: newVal,
      })
      this.isCustomTimeOut = isCustomTimeOut

      this.$emit('isCustomHoursPerDayOutings', isCustomTimeOut)

      const _validRegex = new RegExp(/\d{2}:\d{2}(\s)(am|pm)/)

      if (this.levelInfo.isExtra) {
        this.invalidDaysOut = newVal.map((e) => {
          if (e !== null && e !== '') {
            return _validRegex.test(e)
          }
          return null
        })
      } else {
        this.invalidDaysOut = newVal.map((e) =>
          e !== null ? _validRegex.test(e) : null
        )
      }

      this.isSomeDayInvalidOut = this.invalidDaysOut.some((e) => e === false)

      if (this.isSomeDayInvalidIn || this.isSomeDayInvalidOut) {
        this.isValidTimeOut = false

        const a = this.scheduleDays.map((e, i) => {
          const a = {}
          a.startTime = this.invalidDaysIn[i]
            ? this._parseTime(this.timeIn[i])
            : null
          a.endTime = this.invalidDaysOut[i]
            ? this._parseTime(this.timeOut[i])
            : null
          a.dayOfWeek = e.dayOfWeek
          return a
        })

        this.$emit(
          'invalidScheduleDates',
          structuredClone(
            removeUnableDays(this.$store.getters.getBranch.ableDays, a)
          )
        )
        this.$emit('onIsValidCustomHoursPerDay', this.isValidTimeOut)
        return
      }

      this.scheduleDays = this.scheduleDays.map((e, i) => ({
        ...e,
        startTime: this._parseTime(this.timeIn[i], true),
        endTime: this._parseTime(this.timeOut[i], true),
      }))

      this.$emit('invalidScheduleDates', [])
      this.$emit(
        'onCustomHoursPerDay',
        removeUnableDays(
          this.$store.getters.getBranch.ableDays,
          this.scheduleDays
        )
      )

      this.isValidTimeOut = true
      this.$emit(
        'onIsValidCustomHoursPerDay',
        (this.isValidTimeOut && isCustomTimeOut) || this.isCustomTimeIn
      )
    },
    tolerance: function () {
      this.$emit(
        'onCustomTolerance',
        moment
          .duration(moment(this.tolerance, 'HH:mm').format('HH:mm'))
          .asMinutes()
      )
    },
    model: async function () {
      this.$emit('checkTimeIn', this.model)
      if (this.model === false) {
        this.timeIn = []
        await this._sleep(300)
        this.timeIn = Array(7).fill(null)
        return
      }

      // const setupTimeFromGlobalStateIn = (arr = [], scheduleDays=[]) => {
      //     let array = Array(7).fill(null)
      //     const ableDaysIds = arr
      //       .map((e) => e.id)
      //       .sort((a, b) => a - b)

      //     for (let i = 0; i < ableDaysIds.length; i++) {
      //       console.log(scheduleDays);
      //       array[ableDaysIds[i]-1] = scheduleDays.filter((e)=> e.dayOfWeek === ableDaysIds[i]).map((e)=> this._parseTime("00:00:00"))[0]
      //     }

      //     return array
      //   }
      // console.log(setupTimeFromGlobalStateIn(this.$store.getters.getBranch.ableDays, this.levelInfo.scheduleDays));

      // this.timeIn = [this._parseTime("00:00:00")]
      // this.timeIn = setupTimeFromGlobalStateIn(this.$store.getters.getBranch.ableDays, this.levelInfo.scheduleDays)
      // this.$emit("onCustomSwitch", this.model);

      const setupTimeFromGlobalStateIn = (arr = [], scheduleDays = []) => {
        let array = Array(7).fill(null)
        const ableDaysIds = arr.map((e) => e.id).sort((a, b) => a - b)

        for (let i = 0; i < ableDaysIds.length; i++) {
          // DEFAULT TIME IF IS EXTRA LEVEL
          if (this.levelInfo.isExtra) {
            array[ableDaysIds[i] - 1] =
              scheduleDays.length === 0
                ? ''
                : scheduleDays
                    .filter((e) => e.dayOfWeek === ableDaysIds[i])
                    .map((e) => this._parseTime(e.startTime) || '')[0] || ''
          } else {
            array[ableDaysIds[i] - 1] =
              scheduleDays.length === 0
                ? 'hh:mm am'
                : scheduleDays
                    .filter((e) => e.dayOfWeek === ableDaysIds[i])
                    .map((e) => this._parseTime(e.startTime) || 'hh:mm am')[0]
          }
        }

        return array
      }
      this.timeIn = []
      await this._sleep(300)
      this.timeIn = Array(7).fill(null)
      this.timeIn = setupTimeFromGlobalStateIn(
        this.$store.getters.getBranch.ableDays,
        this.levelInfo.scheduleDays
      )
    },
    invalidScheduleDates: async function () {
      this.invalidDates = structuredClone(this.invalidDatesInitialState)
      await this._sleep(50)
      for (const key in this.invalidScheduleDates) {
        this.invalidDates[key] = this.invalidScheduleDates[key]
      }
    },
    levelInfo: async function () {
      this.userPermissionFieldsHandler()
      this.isSomeDayInvalidIn = []
      this.isSomeDayInvalidOut = []
      this.invalidDaysIn = []
      this.invalidDaysOut = []
      this.invalidDates = structuredClone(this.invalidDatesInitialState)

      if (this.levelInfo.scheduleDays) {
        const isScheduleEntriesActive = this.levelInfo.scheduleDays.every(
          (e) => e.startTime === null || e.startTime === undefined
        )
        this.model = !isScheduleEntriesActive
      }

      this.timeIn = []
      await this._sleep(300)

      if (this.levelInfo.customSchedule === false) {
        const setupTimeFromGlobalState = (ableDays = [], setTime = '') => {
          let array = Array(7).fill(null)
          const ableDaysIds = ableDays.map((e) => e.id).sort((a, b) => a - b)

          for (let i = 0; i < ableDaysIds.length; i++) {
            array[ableDaysIds[i] - 1] =
              setTime === null ? '' : this._parseTime(setTime)
          }

          return array
        }

        this.timeOut = setupTimeFromGlobalState(
          this.$store.getters.getBranch.ableDays,
          this.levelInfo.departureTime
        )
        this.timeIn = setupTimeFromGlobalState(
          this.$store.getters.getBranch.ableDays,
          null
        )
        return
      }

      // here you set custom schedule hrs and remove saturday and sunday
      const mondayInt = 0
      const fridayInt = 5
      if (this.levelInfo.scheduleDays != undefined) {
        // DEFAULT TIME IF IS EXTRA LEVEL
        const setupTimeFromGlobalState = (arr = [], scheduleDays = []) => {
          let array = Array(7).fill(null)
          const ableDaysIds = arr.map((e) => e.id).sort((a, b) => a - b)

          for (let i = 0; i < ableDaysIds.length; i++) {
            array[ableDaysIds[i] - 1] =
              scheduleDays
                .filter((e) => e.dayOfWeek === ableDaysIds[i])
                .map((e) => this._parseTime(e.endTime) || '')[0] || ''
          }

          return array
        }

        // DEFAULT TIME IF IS EXTRA LEVEL
        const setupTimeFromGlobalStateIn = (arr = [], scheduleDays = []) => {
          let array = Array(7).fill(null)
          const ableDaysIds = arr.map((e) => e.id).sort((a, b) => a - b)

          for (let i = 0; i < ableDaysIds.length; i++) {
            array[ableDaysIds[i] - 1] =
              scheduleDays
                .filter((e) => e.dayOfWeek === ableDaysIds[i])
                .map((e) => this._parseTime(e.startTime) || '')[0] || ''
          }

          return array
        }

        // await this._sleep()

        this.timeOut = setupTimeFromGlobalState(
          this.$store.getters.getBranch.ableDays,
          this.levelInfo.scheduleDays
        )
        this.timeIn = setupTimeFromGlobalStateIn(
          this.$store.getters.getBranch.ableDays,
          this.levelInfo.scheduleDays
        )
        const transform2Digits = (num) =>
          num.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })
        this.tolerance =
          transform2Digits(Math.floor(this.levelInfo.minutesLate / 60)) +
          ':' +
          transform2Digits(this.levelInfo.minutesLate % 60)
        //  this.model = this.levelInfo.customSchedule
      }
    },
  },
}
</script>

<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}

.border-red {
  border-color: red !important;
}

.border-section {
  border: 1px solid;
  border-color: #ccc;
  border-radius: 0.5rem;
}

.border-tol {
  border: 1px solid;
  border-color: #000;
  border-radius: 0.5rem;
}

.datepicker-container {
  padding: 5px;
}

.text-disabled {
  color: #ccc;
}
.custom-border {
  border-radius: 0.5rem;
  background: #f44336;
  text-transform: capitalize !important;
  border-color: #ccc !important;
}
.center_btns {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

/* override vuetify container class*/
.container {
  padding-top: 10px;
}

.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
  align-self: center;
  margin-left: auto;
}
.lds-dual-ring:after {
  content: ' ';
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #ef565b;
  border-color: #ef565b transparent #ef565b transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes ws_new_entry_bg_color {
  from {
    box-shadow: rgb(247, 0, 0) 0px 30px 60px -12px inset,
      rgb(255, 0, 0) 0px 18px 36px -18px inset;
  }
  to {
    box-shadow: transparent;
  }
}

.invalid_date {
  border-radius: 10px;
  animation-name: ws_new_entry_bg_color;
  animation-duration: 5s;
  animation-fill-mode: forwards;
  border-radius: 20px;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
